import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-toolbar py-3 py-lg-6" }
const _hoisted_2 = { class: "app-container d-flex flex-stack" }
const _hoisted_3 = { class: "page-title d-flex flex-column justify-content-center flex-wrap me-3" }
const _hoisted_4 = {
  key: 0,
  class: "page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0"
}
const _hoisted_5 = {
  key: 1,
  class: "breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<li class=\"breadcrumb-item text-muted\"><a class=\"text-muted text-hover-primary\" href=\"/metronic8/demo1/index.html\"> Home </a></li><li class=\"breadcrumb-item\"><span class=\"bullet bg-gray-500 w-5px h-2px\"></span></li><li class=\"breadcrumb-item text-muted\">Account</li>", 3)
const _hoisted_9 = [
  _hoisted_6
]
const _hoisted_10 = { class: "d-flex gap-3" }
const _hoisted_11 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "app-content flex-column-fluid" }
const _hoisted_16 = { class: "app-container" }
const _hoisted_17 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_18 = { class: "card-body py-11 py-md-9 position-relative" }
const _hoisted_19 = { class: "d-flex flex-wrap flex-sm-nowrap" }
const _hoisted_20 = { class: "flex-grow-1" }
const _hoisted_21 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_22 = { class: "d-flex flex-column" }
const _hoisted_23 = { class: "d-flex flex-wrap align-items-center break-all mb-2" }
const _hoisted_24 = { class: "text-gray-900 fs-2 fw-bolder text-uppercase me-4" }
const _hoisted_25 = { class: "d-flex flex-wrap gap-7 fw-semibold fs-6 mb-4 pe-2 mt-2" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { class: "svg-icon svg-icon-2" }
const _hoisted_28 = { class: "text-gray-400 ms-1" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "svg-icon svg-icon-2" }
const _hoisted_31 = { class: "text-gray-400 ms-1" }
const _hoisted_32 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_33 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_34 = { class: "d-flex flex-wrap" }
const _hoisted_35 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = { class: "fs-2 fw-bold counted" }
const _hoisted_38 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_39 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_40 = { class: "d-flex align-items-center" }
const _hoisted_41 = { class: "fs-2 fw-bold counted" }
const _hoisted_42 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_43 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_44 = { class: "d-flex align-items-center" }
const _hoisted_45 = { class: "fs-2 fw-bold counted" }
const _hoisted_46 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_47 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = { class: "fs-2 fw-bold counted" }
const _hoisted_50 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_51 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_52 = { class: "d-flex align-items-center" }
const _hoisted_53 = { class: "fs-2 fw-bold counted" }
const _hoisted_54 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_55 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_56 = { class: "d-flex align-items-center" }
const _hoisted_57 = { class: "fs-2 fw-bold counted" }
const _hoisted_58 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_59 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mt-5"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle fs-2tx text-warning" }, null, -1)
const _hoisted_61 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_62 = { class: "fs-6 text-gray-800 ps-5" }
const _hoisted_63 = { class: "card" }
const _hoisted_64 = { class: "card-header" }
const _hoisted_65 = { class: "card-title" }
const _hoisted_66 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_MBDatatable = _resolveComponent("MBDatatable")!
  const _component_RefundConfirmationModal = _resolveComponent("RefundConfirmationModal")!
  const _component_ManualProcessingModal = _resolveComponent("ManualProcessingModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (0)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, " Account Overview "))
            : _createCommentVNode("", true),
          (0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary text-gray-600",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _createElementVNode("span", _hoisted_11, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.backToList")), 1)
          ]),
          (_ctx.refStatus == _ctx.refundStatus.Created)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modal_refund_confirmation",
                disabled: _ctx.loading
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("refundProcessing.button.confirmRefund")), 1)
              ], 8, _hoisted_12))
            : _createCommentVNode("", true),
          (
            _ctx.refStatus == _ctx.refundStatus.Approve ||
            _ctx.refStatus == _ctx.refundStatus.Failed
          )
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-primary",
                disabled: _ctx.loading,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onExecuteButtonClicked && _ctx.onExecuteButtonClicked(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("refundProcessing.button.executeRefund")), 1)
              ], 8, _hoisted_13))
            : _createCommentVNode("", true),
          (_ctx.refStatus == _ctx.refundStatus.Error)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn btn-primary",
                "data-bs-toggle": "modal",
                "data-bs-target": "#modal_manual_processing",
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.$t("refundProcessing.button.manualProcessing")), 9, _hoisted_14))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.refundOrderOverviewData.sales_order_no), 1),
                      (_ctx.refundOrderOverviewData.status)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass([
                        _ctx.getStatus(_ctx.refundOrderOverviewData.status, _ctx.t).value.color
                      , "badge"])
                          }, _toDisplayString(_ctx.getStatus(_ctx.refundOrderOverviewData.status, _ctx.t).value.title), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, [
                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/id.svg" })
                        ]),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("refundProcessing.information.refundNo")) + ": " + _toDisplayString(_ctx.refundOrderOverviewData.refund_order_no || "--"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, [
                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/id.svg" })
                        ]),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("refundProcessing.information.yabandOrderID")) + ": " + _toDisplayString(_ctx.refundOrderOverviewData.pay_order_no || "--"), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      (_ctx.refundOrderOverviewData.amount)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, _toDisplayString((_ctx.refundOrderOverviewData.currency == "EUR"
                              ? "€ "
                              : "¥ ") +
                            _ctx.$currency.currency(
                              _ctx.refundOrderOverviewData.amount,
                              2,
                              ",",
                              ".",
                              ""
                            )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("refundProcessing.information.refundAmount")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                        _ctx.refundOrderOverviewData.customer_firstname ||
                        _ctx.refundOrderOverviewData.customer_lastname
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.refundOrderOverviewData.customer_firstname +
                            " " +
                            _ctx.refundOrderOverviewData.customer_lastname), 1)
                            ]),
                            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("refundProcessing.information.customer")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.refundOrderOverviewData.refund_apply_time
                              ? _ctx.formatUtcDate(
                                  _ctx.refundOrderOverviewData.refund_apply_time,
                                  "YYYY-MM-DD"
                                )
                              : "--"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t("refundProcessing.information.applyDate")), 1)
                      ]),
                      (_ctx.refundOrderOverviewData.created_at)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.formatUtcDate(
                              _ctx.refundOrderOverviewData.created_at,
                              "YYYY-MM-DD"
                            )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("refundProcessing.information.creationDate")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.refundOrderOverviewData.commercial_invoice_no
                              ? _ctx.refundOrderOverviewData.commercial_invoice_no
                              : "--"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t("refundProcessing.information.commercialInvoiceNo")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.refundOrderOverviewData.credit_note_no
                              ? _ctx.refundOrderOverviewData.credit_note_no
                              : "--"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t("refundProcessing.information.creditNoteNo")), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            (_ctx.refundOrderOverviewData.warn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("refundProcessing.information.warningText")), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("refundProcessing.information.productList")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_component_MBDatatable, {
              loading: _ctx.loading,
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              order: "desc",
              "enable-items-per-page-dropdown": true,
              "current-page": _ctx.currentPage,
              total: _ctx.total,
              "rows-per-page": _ctx.pageSize,
              onCurrentChange: _ctx.onCurrentPageChange,
              onItemsPerPageChange: _ctx.onRowsPerPageChange,
              onSort: _ctx.onColumnSort
            }, {
              "cell-brand": _withCtx(({ row: item }) => [
                (_openBlock(), _createBlock(_component_product_info, {
                  key: item.id,
                  gallery: [
                  {
                    id: item.id,
                    origin_url: item.image,
                  },
                ],
                  name: item.name,
                  name_en: item.name_en,
                  source_link: '',
                  brand_id: item.brand
                }, null, 8, ["gallery", "name", "name_en", "brand_id"]))
              ]),
              "cell-brand_article_no": _withCtx(({ row: item }) => [
                (_openBlock(), _createBlock(_component_sku_info, {
                  key: item.id,
                  brand_article_no: item.brand_article_no,
                  color: item.original_color,
                  size: item.size,
                  product_identifier_id: item.product_identifier_id
                }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"]))
              ]),
              "cell-guid": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.guid ? item.guid : "--"), 1)
              ]),
              "cell-unit_price": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.unit_price
                  ? "€ " + _ctx.$currency.currency(item.unit_price, 2, ",", ".", "")
                  : "--"), 1)
              ]),
              "cell-total": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.total
                  ? "€ " + _ctx.$currency.currency(item.total, 2, ",", ".", "")
                  : "--"), 1)
              ]),
              _: 1
            }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_RefundConfirmationModal, {
      id: _ctx.$route.params.id,
      "refund-order-no": _ctx.refundOrderOverviewData.refund_order_no,
      "order-no": _ctx.refundOrderOverviewData.sales_order_no,
      amount: _ctx.refundOrderOverviewData.amount,
      currency: _ctx.refundOrderOverviewData.currency,
      onUpdateList: _ctx.getRefundOrderOverviewData
    }, null, 8, ["id", "refund-order-no", "order-no", "amount", "currency", "onUpdateList"]),
    _createVNode(_component_ManualProcessingModal, {
      id: _ctx.$route.params.id,
      "refund-order-no": _ctx.refundOrderOverviewData.refund_order_no,
      onUpdateList: _ctx.getRefundOrderOverviewData
    }, null, 8, ["id", "refund-order-no", "onUpdateList"])
  ], 64))
}